import React from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { StarRounded } from '@mui/icons-material';
import { theme } from '../../../theme';
import { useNavigate } from 'react-router';


function TopCardsSection({ drafts }) {
    const navigate = useNavigate();

    function navigateToDraft(draft) {
        navigate(`/staffReview/${draft.id}`);
    }

    return (
        <Stack width='100%' divider={<Divider />} sx={{
            border: '1px solid',
            borderRadius: '8px',
            borderColor: theme.palette.border.main,
            backgroundColor: 'white',
        }}>
            <Stack p={2} width='100%'>
                <Typography variant='bold' fontSize='16px'>Highest Impact Cards</Typography>
                <Typography variant='light' fontSize='12px'>If you only have limited time to make changes right now, start here with the cards with the highest uncaptured estimated savings.</Typography>
            </Stack>
            <Stack width='100%' divider={<Divider />}>
                { drafts.map((draft) => (
                    <Stack key={draft.id} py={1} px={2} direction='row' alignItems='center' justifyContent='space-between' onClick={() => navigateToDraft(draft)} style={{
                        cursor: 'pointer',
                    }}>
                        <Stack spacing={1} direction='row' alignItems='center'>
                            <StarRounded style={{ color: theme.palette.primary.main }}/>
                            <Stack>
                                <Typography fontSize='14px'>{draft.card.name}</Typography>
                                <Typography fontSize='12px'>Dr. {draft.card.doctor.last_name}, {draft.card.doctor.first_name}</Typography>    
                            </Stack>
                        </Stack>
                        <Typography color={theme.palette.subtext.main}>
                            <NumericFormat
                                value={draft.uncaptured_savings_opportunity / 100}
                                displayType='text'
                                thousandSeparator={true}
                                prefix='$'
                                suffix={' Uncaptured Estimated Savings'}
                            />
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    )
}

export default TopCardsSection;
